var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6098 11.3899C21.8798 13.6599 21.8798 17.3401 19.6098 19.6101C17.3399 21.88 13.6596 21.88 11.3897 19.6101C9.11981 17.3401 9.11981 13.6599 11.3897 11.3899C13.6596 9.12002 17.3399 9.12002 19.6098 11.3899Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2812 0H8.71875C3.91094 0 0 3.91094 0 8.71875V22.2812C0 27.0891 3.91094 31 8.71875 31H22.2812C27.0891 31 31 27.0891 31 22.2812V8.71875C31 3.91094 27.0891 0 22.2812 0ZM15.5 23.25C11.2267 23.25 7.75 19.7742 7.75 15.5C7.75 11.2258 11.2267 7.75 15.5 7.75C19.7733 7.75 23.25 11.2258 23.25 15.5C23.25 19.7742 19.7733 23.25 15.5 23.25ZM24.2188 7.75C23.6838 7.75 23.25 7.31624 23.25 6.78125C23.25 6.24614 23.6838 5.8125 24.2188 5.8125C24.7537 5.8125 25.1875 6.24614 25.1875 6.78125C25.1875 7.31624 24.7537 7.75 24.2188 7.75Z",
    fill: "#E3E3E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.71b3cae80aea691a9a1eded3390c3ceb.svg";
export { ForwardRef as ReactComponent };